import {configMt} from "../../constant/initDrawing";
import MainMTWrapper from "../../components/live2/mt/MainMTWrapper";

const config = {
    ...configMt,
    type: "tn"
}

const Live2TNPage = () => {
    return <MainMTWrapper config={config}/>
}

export default Live2TNPage;